import React, { FC } from 'react';
import styled from 'styled-components';
import { CellWrapper, TextWrapperWithEllipsis } from './component';

const RoleNameWrapper = styled(TextWrapperWithEllipsis)`
  padding: 0 var(--spacing-05);
`;

type Props = {
  roleName: string;
  onWrapperClick: () => void;
};
export const RoleForProjectView: FC<Props> = ({ roleName, onWrapperClick }) => {
  return (
    <CellWrapper onClick={onWrapperClick}>
      <RoleNameWrapper>{roleName}</RoleNameWrapper>
    </CellWrapper>
  );
};
